import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, Row, Col } from "reactstrap"

import { Link } from "react-router-dom"

// components
import Applications from "pages/Dashboard/applications"

// services
import ApplicationService from "../../services/applications/Application.service"
import Staff from "services/staff/Staff"
import ApplicationFilter from "components/Filter/ApplicationFilter"

let appService = null
let plasticsUser = null
let staffService = new Staff()

const Returned = () => {
  const [menu, setMenu] = useState(false)
  const [user, setuser] = useState()
  const [mounted, setmounted] = useState(false)
  const [returned, setreturned] = useState()
  const [searchMode, setsearchMode] = useState(false)
  const [filterValues, setFilterValues] = useState({
    search: "",
    application_status: "",
    date_from: "",
    date_to: "",
    officer_id: "",
  })

  const toggle = () => {
    setMenu(!menu)
  }

  useEffect(() => {
    const userObj = JSON.parse(localStorage.getItem("authUser"))
    appService = new ApplicationService(userObj)

    setuser(userObj)
    plasticsUser = appService.getStrategy("officer")
    plasticsUser.getReturnedApplications(userObj.id, 1).then(response => {
      console.log(response)
      if (response.status) {
        setreturned(response.data)
        setmounted(true)
      }
    })
  }, [])

  const paginate = page => {
    const userObj = JSON.parse(localStorage.getItem("authUser"))
    // If we are in search mode, we will call the search endpoint instead
    if (searchMode) {
      appService.searchApplications(filterValues, page).then(response => {
        setreturned(response.data)
      })
    } else {
      plasticsUser.getReturnedApplications(userObj.id, page).then(response => {
        if (response.status) {
          setreturned(response.data)
        }
      })
    }
  }

  const initiateSearch = data => {
    data = { ...data, application_status: "SENT_BACK_HoD", officer_id: user.id }
    setsearchMode(true)
    setFilterValues(data)
    appService.searchApplications(data, null).then(response => {
      if (response?.code && response.code == 200) {
        if (response.data.total == 0) {
          setreturned({ data: [] })
        } else {
          setreturned(response.data)
        }
      } else {
        setreturned({ data: [] })
      }
    })
  }

  const turnOffSearchMode = () => {
    setsearchMode(false)
    paginate(0)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Returned | Staff</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={8}>
                <h6 className="page-title">Returned</h6>
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active">
                    All returned applications will show up here.
                  </li>
                </ol>
              </Col>
            </Row>
          </div>

          {mounted ? (
            <Row>
              <ApplicationFilter allApplications={false} handleSearch={initiateSearch} turnOffSearch={turnOffSearchMode} />
              <Applications
                viewOnly={false}
                user={user}
                data={returned}
                paginate={paginate}
              />
            </Row>
          ) : null}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Returned
